import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrl: './callback.component.css',
    standalone: false
})
export class CallbackComponent implements OnInit{

  constructor(
    private readonly authService: AuthService, private readonly router: Router ){}

  ngOnInit(): void {
    this.authService.userManager.signinCallback().finally(() => {

      this.authService.completeAuthentication();
      this.router.navigate(['']);
    })
  }
}
